import React, { useEffect, useState } from "react";
import { Row, Col, Tag, Popover, Modal, notification, Button, } from "antd";

import DrawerVeiculoCliente from "./drawer";
import api from '../../services/api';
import { useStateValue } from "../../state";
import { listagemActions, manutencaoActions } from "../../actions";
import { PesquisaOrdenacao, TabelaDados, Editar, Excluir, BreadcrumbPage } from "../../components";
import { DeleteOutlined, EditOutlined, ExclamationCircleOutlined, PlusOutlined, EyeOutlined } from "@ant-design/icons";
import ModalDetalheVeiculo from "../../components/modals/modalDetalheVeiculo/index.js";

export default function VeiculoCliente() {

    const [{ ui, manutencao }, dispatch] = useStateValue();
    const [editando, setEditando] = useState(false);
    const [openDrawerVeiculo, setOpenDrawerVeiculo] = useState(false);
    const [openModalDetalheVeiculo, setOpenModalDetalheVeiculo] = useState(false);
    const [dadosDetalhesVeiculo, setDadosDetalhesVeiculo] = useState(null);

    useEffect(() => {
        dispatch({ type: listagemActions.CHANGE, data: { outrosFiltros: '', filtro: '', ordem: '+vec_descricao' } })
    }, []);

    function editarVeiculoCliente(record) {
        setEditando(true);
        dispatch({ type: manutencaoActions.CHANGE, data: { dados: record } });
    }

    const modalExcluir = (dados) => {
        Modal.confirm({
            title: 'Excluir?',
            icon: <ExclamationCircleOutlined />,
            content: `Deseja realmente excluir o Veículo ${dados.vei_descricao}?`,
            okText: 'Sim',
            cancelText: 'Não',
            centered: true,
            onOk() {
                excluirVeiculoCliente(dados);
            }
        });
    };

    function excluirVeiculoCliente(dados) {
        api.delete(`VeiculoCliente/Excluir/${dados.vec_id}`).then(
            (res) => {
                notification.success({ message: 'Sucesso!', description: 'Veículo do cliente excluído com sucesso!' });
                dispatch({ type: manutencaoActions.CHANGE, data: { dados: null } });
            }).catch(
                (erro) => {
                    modalInativarVeiculoCliente(dados);
                    console.log(erro);
                }
            ).finally(
                () => {
                    dispatch({ type: listagemActions.CHANGE, data: { ordem: '+vec_descricao' } });
                });
    }

    const modalInativarVeiculoCliente = (dados) => {
        Modal.confirm({
            title: 'Aviso!',
            icon: <ExclamationCircleOutlined />,
            content: `Não foi possível excluir o veículo ${dados.vec_descricao}. Deseja inativar este veículo?`,
            okText: 'Sim',
            cancelText: 'Não',
            centered: true,
            onOk() {
                inativarVeiculoCliente(dados);
            }
        });
    };

    function inativarVeiculoCliente(dados) {
        dados.vec_ativo = false;
        api.put(`VeiculoCliente/Editar`, dados).then(
            res => {
                notification.success({ message: 'Sucesso!', description: 'Veículo inativado com sucesso!' })
            }
        ).catch(
            error => {
                console.log(error);
            }
        ).finally(
            () => {
                dispatch({ type: listagemActions.CHANGE, data: { ordem: '+vec_descricao' } });
            }
        )
    }

    async function visualizarVeiculo(record) {
        try {
        
            let data = await api.get(`VeiculoCliente/BuscarDetalhesVeiculo/${record.vec_id}`);
            console.log("REcord" , record )
            if (data.status === 200) {
                console.log("Abrindo modal...");
                setDadosDetalhesVeiculo(data.data);
                setOpenModalDetalheVeiculo(true);
            }
        } catch (error) {
            notification.error({
                message: 'Erro ao carregar dados do veículo',
                description: 'Não foi possível carregar os detalhes do veículo. Tente novamente.'
            });
        }
    }


    return (
        <div className="p-10">
            <Row align="middle" justify="space-between" gutter={[8, 0]} className="col-pagina-breadcrumb">
                <Col className="col-w-100">
                    <BreadcrumbPage />
                </Col>
                <Col className="col-mob-100">
                    <Row align="middle" justify="end">
                        <Col>
                            <Button type="primary" icon={<PlusOutlined />} size="middle" onClick={() => setOpenDrawerVeiculo(true)}>NOVO</Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <PesquisaOrdenacao opcoesOrdenacao={[
                { label: "Nome A - Z", value: "+vec_descricao" },
                { label: "Nome Z - A", value: "-vec_descricao" },
                { label: "Código Crescente", value: "+vec_id" },
                { label: "Código Decrescente", value: "-vec_id" },
            ]}
            />
            <div className="tabela">
                <TabelaDados url="veiculoCliente/listar" colunas={[
                    {
                        title: 'Código',
                        width: 75,
                        align: 'center',
                        render: ({ vec_id, vec_ativo }) => (
                            <Popover content={vec_ativo ? 'Ativo' : 'Inativo'} placement="right" className="w-100">
                                <Tag color={vec_ativo ? 'processing' : 'default'}>
                                    <b>{vec_id}</b>
                                </Tag>
                            </Popover>
                        ),
                    },
                    {
                        title: 'Nome',
                        render: ({ vec_descricao }) => (
                            <div>
                                <b>{vec_descricao}</b>
                            </div>
                        ),
                    },
                    {
                        title: 'Cliente',
                        render: ({ pes_nome }) => (
                            <div>
                                <b>{pes_nome}</b>
                            </div>
                        ),
                    },
                    {
                        title: 'Modelo',
                        render: ({ vec_modelo }) => (
                            <div>
                                <b>{vec_modelo}</b>
                            </div>
                        ),
                    },
                    {
                        title: 'Placa',
                        render: ({ vec_placa }) => (
                            <div>
                                <b>{vec_placa}</b>
                            </div>
                        ),
                    },
                    {
                        title: 'Ações',
                        dataIndex: '',
                        key: 'x',
                        align: 'center',
                        width: 95,
                        fixed: 'right',
                        render: (record, dados) => (
                            <div>
                                <Row align="middle" justify="center" gutter={[5, 0]}>
                                    <Col>
                                        <Button type="default" onClick={() => { visualizarVeiculo(record); }} icon={<EyeOutlined />} />
                                    </Col>
                                    <Col>
                                        <Editar onClick={() => {
                                            editarVeiculoCliente(record);
                                        }} icon={<EditOutlined />}
                                        />
                                    </Col>
                                    <Col>
                                        <Excluir icon={<DeleteOutlined />} onClick={() => { modalExcluir(record) }} />
                                    </Col>
                                </Row>
                            </div>
                        ),
                    },
                ]} />
            </div>
            <DrawerVeiculoCliente cadVeiculoCliente={true} editando={{ editando, setEditando }} openDrawer={openDrawerVeiculo} setOpenDrawer={setOpenDrawerVeiculo} />
            <ModalDetalheVeiculo exibirModal={openModalDetalheVeiculo} fecharModal={() => setOpenModalDetalheVeiculo(false)} dadosModal={dadosDetalhesVeiculo} />
        </div>
    )
}
